import React from 'react';

import { ModalComponent } from 'baseComponents/ModalComponent';

import { TextComponent } from 'baseComponents/TextComponent';
import { ButtonComponent } from 'baseComponents/ButtonComponent';
import './removeCampaignModal.scss';

interface Props {
  isModalOpen: boolean;
  closeModal: () => void;
  handleDeleteCampaign: () => void;
}

export const RemoveCampaignModal: React.FC<Props> = (props) => {
  return (
    <ModalComponent
      title='Remove campagin'
      close={props.closeModal}
      open={props.isModalOpen}
    >
      <TextComponent text='Are you sure you want to delete campaign?' />
      <div className='remove-campaign-btns'>
        <ButtonComponent
          appereance='primary'
          size='middle'
          onClick={props.handleDeleteCampaign}
          label='Delete campaign'
          fullWidth
        />
        <ButtonComponent
          appereance='secondary'
          size='middle'
          onClick={props.closeModal}
          label='Cancel'
          fullWidth
        />
      </div>
    </ModalComponent>
  );
};
